<template>
  <div class="hello">
    <div class="filters md-elevation-4">
      <div class="md-layout">
        <div class="md-layout-item p10"></div>
      </div>
    </div>
    <div class="md-layout table-label-wrapper">
      <div class="md-layout-item p10 table-label">
        <h1>Monthly grades</h1>
      </div>
    </div>

    <div class="result table md-elevation-4">
      <table width="100%">
        <thead>
          <tr>
            <th>Id</th>
            <th>Type</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(score, index) in scores">
            <td>{{score.assessment.id}}</td>
            <td>{{score.assessment.type}}</td>
            <td>{{calculateScore(score)}}</td>
          </tr>
        </tbody>
      </table>
      <paginator
        @prev="onPrev"
        @next="onNext"
        :page="page"
        :pages="pages"
        :limit="limit"
        :count="count"
        :total="totalCount"
      />
    </div>
  </div>
</template>

<script>
import Paginator from "./Paginator";
import _ from "lodash";

export default {
  name: "MonthlyGrades",
  props: ["user", "isAdmin", "userType"],
  mounted() {
    this.getScore();
  },
  computed: {
    pages() {
      return Math.ceil(this.totalCount / this.limit) - 1;
    },
    offset() {
      return this.page * this.limit;
    },
    orderDirection() {
      return this.direction ? "DESC" : "ASC";
    },
    filterStatusFormated() {
      return this.filterStatus === "" ? null : this.filterStatus;
    }
  },
  data() {
    return {
      page: 0,
      limit: 10,
      totalCount: 0,
      count: 0,
      //query: require("../graphql/Scores.gql"),
      order: "id",
      direction: 0,
      scores: null
    };
  },
  components: {
    Paginator
  },
  methods: {
    getScore() {
      return Promise.all([
        this.$apollo.query({
          query: require("../graphql/Scores.gql"),
          fetchPolicy: "no-cache",
          variables: {
            offset: 0,
            limit: 0
          }
        }),
        this.$apollo.query({
          query: require("../graphql/Templates.gql"),
          fetchPolicy: "no-cache",
          variables: {
            offset: 0,
            limit: 0
          }
        })
      ]).then(data => {
        let templates = data[1].data.templates.edges;
        let scores = data[0].data.scores.scores;
        this.scores = scores;
        this.templates = templates;
      });
    },
    calculateScore(score) {
      let templateScore = {};
      let submissions = score.submissions.edges;
      submissions.forEach(submission => {
        if (submission.submissionDatas && submission.submissionDatas.length) {
          submission.submissionDatas.forEach(submissionData => {
            if (submissionData.template && submissionData.status) {
              let templateId = submissionData.template.id;
              if (!templateScore[templateId]) {
                templateScore[templateId] = {};
              }
              if (!templateScore[templateId][submissionData.template.name]) {
                templateScore[templateId][submissionData.template.name] = [];
              }
              templateScore[templateId][submissionData.template.name].push(
                submissionData.grade
              );
            }
          });
        }
      });
      let monthly = _.find(this.templates, { name: "monthly" });
      let domains = {};
      monthly.childrens.forEach(el => {
        domains[el.name] = [];
        if (templateScore[el.id]) {
          domains[el.name].push(templateScore[el.id]);
        }
        el.childrens.forEach(subdomain => {
          if (templateScore[subdomain.id]) {
            domains[el.name].push(templateScore[subdomain.id]);
          }
        });
      });
      console.log(domains, templateScore);
      return 0;
    },
    onPrev() {
      if (this.page > 0) {
        this.page--;
      }
    },
    onNext() {
      if (this.page < this.pages) {
        this.page++;
      }
    },
    onResult(data) {
      let totalCount = data.data.scores.count;
      this.totalCount = totalCount;
      this.count = data.data.scores.length;
    },
    onOrder(field) {
      if (this.order == field) {
        this.direction = !this.direction;
      } else {
        this.direction = 0;
        this.order = field;
      }
    }
  },
  watch: {
    page(val) {
      this.getScore(val);
    }
  }
};
</script>
